import config from '__api/config';
import { zqhdApi } from '__api/zqhd/creatZqhdRequest';

/* 微信 */
type ConfigDataRequest = {
  url: string;
};
export async function getWxConfigData(request: ConfigDataRequest) {
  const url = config.zqhpLink + '/weChat/api/getJsSdkUiPackage';
  return zqhdApi.fetch<any>(url, request, false, false);
}
